import React from 'react';

import { IconTypographyProps } from './IconTypography.interface';
import { StyledTypography, StyledWrapper } from './IconTypography.styled';

export const IconTypography: React.FC<IconTypographyProps> = ({
  icon,
  text,
  textFontSize,
  textFontWeight,
  textColor,
  iconSize,
  iconColor,
}) => {
  return (
    <StyledWrapper iconSize={iconSize} iconColor={iconColor}>
      {icon}
      <StyledTypography
        fontSize={textFontSize}
        fontWeight={textFontWeight}
        color={textColor}>
        {text}
      </StyledTypography>
    </StyledWrapper>
  );
};
